import { render, staticRenderFns } from "./gold-card.vue?vue&type=template&id=1e70f718&scoped=true&"
import script from "./gold-card.vue?vue&type=script&lang=js&"
export * from "./gold-card.vue?vue&type=script&lang=js&"
import style0 from "./gold-card.vue?vue&type=style&index=0&id=1e70f718&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e70f718",
  null
  
)

export default component.exports